import { isValidElement } from "react"
import { ItemLayout } from "../../types"

export const DefaultItemLayout: ItemLayout = ({
  children,
}) => {
  return isValidElement(children) ? children : Object.values(children)[0]
}
